import loginSlice from "../slices/loginSlice";

export const loginReducers = {
  login: loginSlice,
};
